export default "__VITE_ASSET__ef0f34ef__"